import { useQuery } from 'react-query'
import { useRouter } from 'next/router'

// Libs
import { fetchExploreVendorBlock, ResponseType } from '@/api/fetchExploreVendorBlock'
import { fetchFollowVendorBlock } from '@/api/fetchFollowVendorBlock'
import { useMemberData } from './useMemberData'

// Constants
import { QUERY_KEY } from '@/constants/queryKey'

export const VENDOR_BLOCK_DEFAULT_SIZE = 40

export const useExploreVendorBlockData = () => {
  const router = useRouter()
  const { query } = router
  const { preferenceTag } = query
  const { memberData } = useMemberData()
  const isLogin = memberData?.isLogin
  const { data: exploreVendorBlockData, isFetching } = useQuery<ResponseType>(
    [QUERY_KEY.FETCH_EXPLORE_VENDOR_BLOCK, preferenceTag],
    () => fetchExploreVendorBlock({ size: VENDOR_BLOCK_DEFAULT_SIZE, preferenceTag: preferenceTag as string, queryTime: new Date().toISOString() }),
    {
      enabled: !!preferenceTag && router.isReady && isLogin,
    },
  )
  return {
    exploreVendorBlockData: exploreVendorBlockData?.vendorBlocks || [],
    isExploreVendorBlockDataFetching: isFetching,
  }
}
export const useFollowVendorBlockData = () => {
  const router = useRouter()
  const { memberData } = useMemberData()
  const isLogin = memberData?.isLogin
  const { data: followVendorBlockData, isFetching } = useQuery<ResponseType>(
    QUERY_KEY.FETCH_FOLLOW_VENDOR_BLOCK,
    () => fetchFollowVendorBlock({ size: VENDOR_BLOCK_DEFAULT_SIZE, queryTime: new Date().toISOString() }),
    {
      enabled: router.isReady && isLogin,
    },
  )
  return {
    followVendorBlockData: followVendorBlockData?.vendorBlocks || [],
    isFollowVendorBlockDataFetching: isFetching,
  }
}
